export interface EmailField {
  name: string;
  maxLength: number;
  note?: string;
}

export const emailFields: EmailField[] = [
  { name: '{ name }', note: 'Name of the attendee', maxLength: 40 },
  { name: '{ firstName }', note: "Just attendee's first name", maxLength: 20 },
  { name: '{ lastName }', note: "Just attendee's last name", maxLength: 20 },
  { name: '{ email }', note: 'Email of the attendee', maxLength: 40 },
  { name: '{ attendeeEmail }', note: 'Email of the attendee', maxLength: 40 },
  {
    name: '{ notificationFromName }',
    note: 'From name set in notification settings',
    maxLength: 30,
  },
  { name: '{ webinarTitle }', note: 'The title of the eWebinar', maxLength: 120 },
  {
    name: '{ sessionTime }',
    note: "Attendee's eWebinar session start date and time",
    maxLength: 40,
  },
  {
    name: '{ sessionTime left }',
    note: 'Relative time to start, eg. "in 15 minutes"',
    maxLength: 15,
  },
  { name: '{ registrationLink }', note: 'Link to registration page', maxLength: 100 },
  { name: '{ joinLink }', note: "Attendee's join link", maxLength: 60 },
  { name: '{ replayLink }', note: "Attendee's replay link", maxLength: 60 },
  { name: '{ allWebinarsLink }', note: 'Link to your share all webinars page', maxLength: 80 },
  {
    name: '{ appleCalendarLink }',
    note: 'Add to Apple Calendar',
    maxLength: 250,
  },
  {
    name: '{ googleCalendarLink }',
    note: 'Add to Google Calendar',
    maxLength: 650,
  },
  {
    name: '{ outlookCalendarLink }',
    note: 'Add to Outlook Calendar',
    maxLength: 250,
  },
  {
    name: '{ outlookComCalendarLink }',
    note: 'Add to Outlook.com Calendar',
    maxLength: 350,
  },
  {
    name: '{ yahooCalendarLink }',
    note: 'Add to Yahoo Calendar',
    maxLength: 650,
  },
];
